import * as lazyHero from "../../mxm_base/js/utils/mxmlazy";

$(window).on('load', function () {
    function DisplaySlick(heroImg, heroBody, dots, arrows) {
        dots = (dots === undefined ? true : dots);
        arrows = (arrows === undefined ? true : dots);
        lazyHero.lazyInit(heroImg);
        lazyHero.lazyAfter(heroImg);

        heroImg = heroImg.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: false,
            fade: true,
            speed: 1000,
            autoplay: true,
            asNavFor: '.hero-slider-body',
        });

        heroBody.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            asNavFor: '.hero-slider-img',
            dots: dots,
            arrows: arrows,
            fade: true,
            autoplay: true,
            speed: 1000,
            prevArrow: '<span class="slick-prev"><i class="fal fa-chevron-left"></i></span>',
            nextArrow: '<span class="slick-next"><i class="fal fa-chevron-right"></i></span>',
        });
    }
    var isSlickLoaded = (typeof $.fn.slick !== 'undefined');
    if (isSlickLoaded) {
        // default slider
        var heroImg = $('.default .hero-slider-img');
        var heroBody = $('.default .hero-slider-body');
        if (heroImg && heroBody) {
            DisplaySlick(heroImg, heroBody);
        }

        // default slider
        var heroImg = $('.fadeing .hero-slider-img');
        var heroBody = $('.fadeing .hero-slider-body');
        if (heroImg && heroBody) {
            DisplaySlick(heroImg, heroBody, false, false);
        }
    }
});
